// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyListWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyListWebApiHandler_atRisk,
  RentalManagerUserPropertyListWebApiHandler_atRisk_Path,
  RentalManagerUserPropertyListWebApiHandler_list,
  RentalManagerUserPropertyListWebApiHandler_list_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  RentalManagerUserPropertyListAtRiskDto,
  RentalManagerUserPropertyListDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AtRiskParams {
  includeUserManagementCompanyId?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRisk?: boolean;
  includeFeedClaimAndConvertUpdate?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeTours?: boolean;
  includeUnarchived?: boolean;
  includeUserManagementCompanyId?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export type RentalManagerUserPropertyListWebApiHandler_atRisk_Options = UseQueryOptions<
  RentalManagerUserPropertyListAtRiskDto,
  unknown,
  RentalManagerUserPropertyListAtRiskDto,
  readonly [string, AtRiskParams]
>;

const RentalManagerUserPropertyListWebApiHandler_atRisk_GetKey = (getParams: AtRiskParams) =>
  [RentalManagerUserPropertyListWebApiHandler_atRisk_Path, getParams] as const;

export const RentalManagerUserPropertyListWebApiHandler_atRisk_queryOptions = (getParams: AtRiskParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyListWebApiHandler_atRisk_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyListWebApiHandler_atRisk(getParams),
  }) as const satisfies QueryOptions;

/**
 * List a user's properties that are at risk
 */
export const useRentalManagerUserPropertyListWebApiHandler_atRisk = (
  getParams: AtRiskParams,
  options: Omit<RentalManagerUserPropertyListWebApiHandler_atRisk_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyListWebApiHandler_atRisk_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserPropertyListWebApiHandler_atRisk.getKey = RentalManagerUserPropertyListWebApiHandler_atRisk_GetKey;

export type RentalManagerUserPropertyListWebApiHandler_list_Options = UseQueryOptions<
  RentalManagerUserPropertyListDto,
  unknown,
  RentalManagerUserPropertyListDto,
  readonly [string, ListParams]
>;

const RentalManagerUserPropertyListWebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerUserPropertyListWebApiHandler_list_Path, getParams] as const;

export const RentalManagerUserPropertyListWebApiHandler_list_queryOptions = (getParams: ListParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyListWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyListWebApiHandler_list(getParams),
  }) as const satisfies QueryOptions;

/**
 * List a user's properties
 */
export const useRentalManagerUserPropertyListWebApiHandler_list = (
  getParams: ListParams,
  options: Omit<RentalManagerUserPropertyListWebApiHandler_list_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyListWebApiHandler_list_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserPropertyListWebApiHandler_list.getKey = RentalManagerUserPropertyListWebApiHandler_list_GetKey;
